import { initBlobs } from "./scripts/blobs.js";
import { initNavigation } from "./scripts/navigation.js";

window.addEventListener("load", () => {
  initBlobs();
  initNavigation();
});
